import { styled } from '@mui/material/styles';

const StyledDateRangePicker = styled('div')`
  width: fit-content;
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;

  & .MuiFormControl-root {
    min-width: 170px;
  }

  & .MuiOutlinedInput-root {
    border-radius: 10px;
    background: #ffffff;
  }
`;

export default StyledDateRangePicker;
